import { CircleSpinner } from "common/spinners";
import { CTA } from "common/styleguide/CTA";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import fetchJSON from "lib/fetchJSON";
import { capitalize } from "lib/utils";
import React from "react";
import styles from "./ExperienceEventEmbedModal.scss";

export const EXPERIENCE_EVENT_EMBED_MODAL = "EXPERIENCE_EVENT_EMBED_MODAL";

export class ExperienceEventEmbedModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      embedId: null,
    };
  }

  componentDidMount() {
    const { objectType, objectId } = this.props;
    fetchJSON(`/route_set_overviews?parent_type=${objectType}&parent_id=${objectId}`).then((r) =>
      this.setState({ embedId: r.embed_id })
    );
  }

  refresh = () => {
    const { embedId } = this.state;
    if (!embedId) return;

    fetchJSON(`/route_set_overviews/${embedId}/refresh.json`, null, {
      method: "POST",
    });
  };

  // basic highlight-all on click
  textareaClicked = () => {
    this._iframe.select();
    this._iframe.focus();
  };

  render() {
    const { embedId } = this.state;
    const { onRequestClose, objectType } = this.props;

    return (
      <ModalOverlay
        title="Embed code for"
        maxWidth="400px"
        footer={
          <div className={styles.footer}>
            <CTA link disabled={!embedId} margins={false} onClick={this.refresh}>
              Refetch
            </CTA>
            <CTA margins={false} onClick={onRequestClose}>
              Got It!
            </CTA>
          </div>
        }
        onRequestClose={onRequestClose}
      >
        <div className={styles.body}>
          {embedId ? (
            <textarea
              ref={(r) => {
                this._iframe = r;
              }}
              onClick={this.textareaClicked}
              className={styles.embedCode}
              defaultValue={`<iframe src="https://ridewithgps.com/embeds?type=${
                "public" + capitalize(objectType)
              }&id=${embedId}" style="width: 1px; min-width: 100%; height: 700px; border: none;" scrolling="no"></iframe>`}
            />
          ) : (
            <CircleSpinner size={40} />
          )}
        </div>
      </ModalOverlay>
    );
  }
}
